import { ApiFactory } from '@/api/api-factory';
import ClientSelectedFiltersBuilder from '../models/filters/client/ClientSelectedFiltersBuilder';

const awardsClient = ApiFactory.getAwardsClient();

export default {
  getAwardsData({ commit, dispatch }, awardResultType) {
    return new Promise((resolve, reject) => {
      const action = (index) => {
        const indexId = index.deploymentIndexId;
        dispatch(
          'common/showBusyCursor',
          'Fetching Results ...',
          { root: true },
        );
        awardsClient.getAwardsDataObservable(indexId, awardResultType)
          .subscribe({
            next: (result) => {
              commit('setAwardsResult', result);
              dispatch('common/hideBusyCursor', null, { root: true });
              resolve();
            },
            error: (err) => {
              dispatch('common/hideBusyCursor', null, { root: true });
              reject(err);
            },
          });
      };
      dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
    });
  },

  filterAwardsData({ commit, dispatch, state }, awardResultType) {
    const action = (index) => {
      const indexId = index.deploymentIndexId;
      dispatch(
        'common/showBusyCursor',
        'Fetching Results ...',
        { root: true },
      );
      awardsClient.getFilteredData(indexId, state.selectedFilters, awardResultType)
        .subscribe((result) => {
          commit('updateAwardsData', result);
          dispatch('common/hideBusyCursor', null, { root: true });
        });
    };

    dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
  },

  getLeaderboardsData({ commit, dispatch }) {
    const action = (index) => {
      const indexId = index.deploymentIndexId;

      awardsClient.getLeaderboardObservable(indexId)
        .subscribe((result) => commit('setLeaderboardResult', result));
    };

    dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
  },

  filterLeaderboard({ commit, dispatch, state }, league) {
    const action = (index) => {
      const indexId = index.deploymentIndexId;
      dispatch(
        'common/showBusyCursor',
        'Fetching Data ...',
        { root: true },
      );
      awardsClient.getFilteredLeaderboard(indexId, state.selectedFilters, league)
        .subscribe((result) => {
          commit('updateLeaderboard', result);
          dispatch('common/hideBusyCursor', null, { root: true });
        });
    };

    dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
  },

  toggleFilter({ state, commit }, { fieldId, valueId }) {
    state.filterEngine.toggleValue(fieldId, valueId);
    // commit('incrementFilterVersion');
    const selected = ClientSelectedFiltersBuilder.build(state.filterEngine);

    // if (selected.length === 0) {
    //   state.filterEngine.resetFiltersToDefaultSelections();
    //   selected = ClientSelectedFiltersBuilder.build(state.filterEngine);
    // }
    commit('setSelectedFilters', selected);
    commit('incrementFilterVersion');
  },

  clearAllFilters({ state, commit }) {
    const engine = state.filterEngine;
    if (!engine) {
      return;
    }
    engine.clearAllFilters();
    commit('incrementFilterVersion');
    commit('setSelectedFilters', []);
  },

  getAwardFilters({ dispatch, commit }, { filterType, selectedFilters }) {
    return new Promise((resolve, reject) => {
      const action = (index) => {
        const indexId = index.deploymentIndexId;
        // dispatch(
        //   'common/showBusyCursor',
        //   'Fetching Filters ...',
        //   { root: true },
        // );
        
        awardsClient.getAwardFiltersObservable(indexId, selectedFilters, filterType)
          .subscribe({
            next: (result) => {
              commit('setAwardFilters', result);
              // dispatch('common/hideBusyCursor', null, { root: true });
              resolve(result);
            },
            error: (err) => {
              // dispatch('common/hideBusyCursor', null, { root: true });
              reject(err);
            },
          });
      };
      
      dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
    });
  },

  getAwardResultsData({ commit, dispatch }, awardResultType) {
    return new Promise((resolve, reject) => {
      const action = (index) => {
        const indexId = index.deploymentIndexId;
        dispatch(
          'common/showBusyCursor',
          'Fetching Results ...',
          { root: true },
        );
        awardsClient.getAwardResultsDataObservable(indexId, awardResultType)
          .subscribe({
            next: (result) => {
              commit('setAwardsResultData', result);
              dispatch('common/hideBusyCursor', null, { root: true });
              resolve();
            },
            error: (err) => {
              dispatch('common/hideBusyCursor', null, { root: true });
              reject(err);
            },
          });
      };
      dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
    });
  },

  filterAwardResultsData({ commit, dispatch }, { awardResultType, filterIds }) {
    const action = (index) => {
      const indexId = index.deploymentIndexId;
      dispatch(
        'common/showBusyCursor',
        'Fetching Results ...',
        { root: true },
      );
      awardsClient.getFilteredAwardResults(indexId, filterIds, awardResultType)
        .subscribe((result) => {
          commit('updateAwardsData', result);
          dispatch('common/hideBusyCursor', null, { root: true });
        });
    };

    dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
  },

  resetToDefaults({ state, commit }) {
    const engine = state.filterEngine;
    if (!engine) {
      return;
    }
    engine.resetFiltersToDefaultSelections();
    commit('incrementFilterVersion');
    const selected = ClientSelectedFiltersBuilder.build(state.filterEngine);
    commit('setSelectedFilters', selected);
  },

  getCadreRankingsData({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      const action = (index) => {
        const indexId = index.deploymentIndexId;
        dispatch(
          'common/showBusyCursor',
          'Fetching Results ...',
          { root: true },
        );
        awardsClient.getLeaderboardResults(indexId)
          .subscribe({
            next: (result) => {
              commit('setCadreRankingsData', result);
              dispatch('common/hideBusyCursor', null, { root: true });
              resolve();
            },
            error: (err) => {
              dispatch('common/hideBusyCursor', null, { root: true });
              reject(err);
            },
          });
      };
      dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
    });
  },

  filterCadreRankingsData({ commit, dispatch }, filterIds) {
    const action = (index) => {
      const indexId = index.deploymentIndexId;
      dispatch(
        'common/showBusyCursor',
        'Fetching Results ...',
        { root: true },
      );
      awardsClient.getFilteredLeaderboardResults(indexId, filterIds)
        .subscribe((result) => {
          commit('setCadreRankingsData', result);
          dispatch('common/hideBusyCursor', null, { root: true });
        });
    };

    dispatch('common/executeWhenDeploymentIndexIsAvailable', action, { root: true });
  },
};
